export enum Token {
  WETH = "WETH",
  ARB = "ARB",
  USDC = "USDC",
  GMX = "GMX",
  WBTC = "WBTC",
  USDCE = "USDCE",
}

export const PRICE_BASED_ROW_ID = "price-based-row";
export const OPEN_INTEREST_AND_LEVERAGE_ROW_ID =
  "open-interest-and-leverage-row";
export const LINE_CHART_MARGIN_PARAMS_PX = {
  top: 5,
  right: 30,
  left: 0,
  bottom: 5,
};
